<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'

import Loading from '@/components/loading.vue'
import { Toaster } from '@/components/ui/sonner'
import { useOnboardingSetupStore } from '@/stores/onboarding-setup'
import { useProductTourStore } from '@/stores/product-tour'
import { useUserStore } from '@/stores/user'

const tourStore = useProductTourStore()
const userStore = useUserStore()
const onboardingStore = useOnboardingSetupStore()
const route = useRoute()

onMounted(async () => {
  // Watch for app initialization to complete before fetching tours
  // Tours should only be fetched after user has logged in AND selected a store
  watch(
    () => userStore.isAppInitialized,
    async (initialized) => {
      if (initialized) {
        try {
          // Initialize backend-driven tours only after app is initialized
          // (user is logged in and has selected a store)
          await tourStore.fetchAndActivateTours()
        }
        catch (error) {
          console.error('[App] Failed to initialize tours:', error)
        }
      }
    },
    { immediate: true },
  )

  // Always show congrats pre-prompt when route enters Home (revenue)
  try {
    watch(() => route.path, (path) => {
      const onHome = typeof path === 'string' && path.includes('/home')
      if (onHome) {
        // Clear any session skip so pre-prompt reappears on refresh
        try { sessionStorage.removeItem('attribuly_pre_tour_prompt_skip_session') }
        catch {}

        // Only reset if no tour is active, or if it's a legacy auto-tour we want to suppress
        // Don't reset if user just triggered an intent tour
        if (!tourStore.active) {
          tourStore.setTourType('none')
        }
      }
    }, { immediate: true })
  }
  catch {}
})
</script>

<template>
  <!-- 设置toast提示位置为右上角 -->
  <Toaster position="top-right" />
  <!-- <VueQueryDevtools /> -->

  <Suspense>
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>

    <template #fallback>
      <Loading />
    </template>
  </Suspense>
</template>
